import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import cart from '@/store/modules/cart.module';
import odds from '@/store/modules/odds.module';
import rules from '@/store/modules/rules.module';
import settings from '@/store/modules/settings.module';
import socket from '@/store/modules/socket.module';
import tree from '@/store/modules/tree.module';
import user from '@/store/modules/user.module';
import sport from '@/store/modules/sport.module';
import result from '@/store/modules/result.module';
import marketview from '@/store/modules/marketview.module';
import treeV2 from '@/store/modules/treeV2.module';
import nextEvents from "@/store/modules/nextEvents";
import startingSoon from "@/store/modules/startingSoon";
import bestPlayed from "@/store/modules/bestPlayed";
import previewPrematch from "@/store/modules/previewPrematch";
import detailPrematch from "@/store/modules/detailPrematch";
import previewLive from "@/store/modules/previewLive";
import detailLive from "@/store/modules/detailLive";
import scrollerWidgetEventLive from "@/store/modules/scrollerWidgetEventLive";
import earlyPayout from "@/store/modules/earlyPayout";
import cashout from "@/store/modules/cashout";
import betFreeze from "@/store/modules/betFreeze";
import featuredEvents from "@/store/modules/featuredEvents";
import boostFeaturedEvents from "@/store/modules/boostFeaturedEvents";
import ui from '@/store/modules/ui.module'
import topsports from '@/store/modules/topsports.module'
import sportNavigation from '@/store/modules/sportNavigation'
import printodds from '@/store/modules/printodds.module.js'
import betbuilder from '@/store/modules/betbuilder.js'
import antepost from '@/store/modules/antepost.module'
import createParentBridgePlugin from '@/services/parentBridge/parentBridgePlugin'

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'sport-rev-iframe',
            paths: [
                'cart.bet.odds',
                'cart.odds_variation',
                'cart.odds_sources',
                'cart.created_at',
                'cart.bet.type',
                'cart.bet._multiple_detail',
                'cart.bet._system_detail',
                'cart.bet._integral_detail',
                'cart.bet._integral_detail',
                'cart.combinableMarkets',
                'cart.accepted_bets',
                'cart.accepted_with_change',
                'cart.resolved_review_codes',
            ]
        }),
        // After the persisted state, so the restored slip is the first one posted.
        createParentBridgePlugin()],
    modules: {
        cart,
        odds,
        rules,
        settings,
        socket,
        tree,
        user,
        sport,
        result,
        marketview,
        treeV2,
        nextEvents,
        startingSoon,
        earlyPayout,
        bestPlayed,
        previewPrematch,
        detailPrematch,
        previewLive,
        detailLive,
        scrollerWidgetEventLive,
        cashout,
        betFreeze,
        featuredEvents,
        boostFeaturedEvents,
        ui,
        topsports,
        sportNavigation,
        printodds,
        betbuilder,
        antepost
    }
});
